<template>
  <div>
    <el-dialog width="40%" :title="$t('langcfg.txtDetectConfigure')" :visible.sync="visible">
      <div class="df aic" style="margin-bottom: 10px">
        <div style="font-size: 25px; color: white; flex-shrink: 0">
          {{ $t("langcfg.txtSelectTemplate") }}：
        </div>
        <el-select style="margin: 10px; width: 100%" v-model="detections.template" @change="save">
          <el-option
            class="df aic jcb"
            style="padding-right: 10px"
            v-for="(v, i) in detections.templates"
            :key="i"
            :label="v.default ? $t('langcfg.txtDefaultTemplate') : v.label"
            :value="v.value"
          >
            <span style="float: left">{{
              v.default ? $t("langcfg.txtDefaultTemplate") : v.label
            }}</span>
            <div class="df aic" style="float: right">
              <i
                v-if="!v.default"
                class="iconfont icon-edit"
                style="
                  color: white;
                  font-size: 27px;
                  margin-right: 20px;
                  position: relative;
                  top: 2px;
                "
                @click.stop="editTemplate(v)"
              ></i>
              <i
                v-if="!v.default"
                class="el-icon-delete"
                style="color: white; font-size: 30px"
                @click.stop="deleteTemplate(i)"
              ></i>
            </div>
          </el-option>
        </el-select>
        <i class="el-icon-plus" style="font-size: 30px; color: white" @click="addTemplate"></i>
      </div>
      <template>
        <div style="font-size: 25px; color: white; margin-bottom: 20px">
          {{ $t("langcfg.txtTemplateConfigure") }}：
        </div>
        <div v-if="detections.template && show" class="detect-list" ref="list">
          <el-checkbox
            v-if="v.key !== 'questionnaire' || (v.key === 'questionnaire' && !isDeOrItLanguage)"
            v-model="templateItemsMap[v.key].show"
            v-for="v in currentTemplateItems"
            :key="v.key"
            @change="save"
            :disabled="
              templateItemsMap[v.key].show && currentTemplateItems.filter((v) => v.show).length <= 1
            "
            >{{ $t(`langcfg.${menuMap[v.key].label}`) }}</el-checkbox
          >
        </div>
      </template>
    </el-dialog>
    <el-dialog
      width="500px"
      :title="curTemplate.value ? $t('langcfg.txtEditTemplate') : $t('langcfg.txtAddTemplate')"
      :visible.sync="showTitleDialog"
    >
      <el-input
        :placeholder="$t('langcfg.txtInputTemplateTitle')"
        v-model="curTemplate.label"
        @click.native.stop.prevent="handleClick"
        @touchend.native.stop.prevent="handleClick"
      />
      <div slot="footer" class="df aic jce">
        <el-button @click="saveOrUpdateTemplate">{{ $t("langcfg.txtOK") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import { saveDelectSettings } from "../../../settings";
import { Message } from "../../../mixins";
import EVENTS from "../../../bus";
import { v4 as uuid } from "uuid";
import { DRYEYEMENUS } from "../../../shared/consts";
export default {
  mixins: [Message],
  data() {
    return {
      detections: window.detectSettings[this.type],
      sortable: null,
      showTitleDialog: false,
      origin: null,
      curTemplate: {},
      isDeOrItLanguage: false
    };
  },
  props: {
    show: Boolean,
    type: String
  },
  mounted() {
    this.origin = DRYEYEMENUS.filter((v) => v.key !== "report").reduce(
      (acc, cur) => ((acc[cur.key] = true), acc),
      {}
    );
    this.detections.templates.forEach((v) => {
      let p = v.items.reduce((acc, cur) => ((acc[cur.key] = cur.show), acc), {});
      const combined = { ...this.origin, ...p };
      const updatedItems = v.items.map((item) => ({
        key: item.key,
        show: combined[item.key]
      }));
      Object.entries(combined).forEach(([key, show]) => {
        if (!v.items.find((item) => item.key === key)) {
          updatedItems.push({ key, show });
        }
      });
      this.$set(v, "items", updatedItems);
    });
    this.save();
    this.isDeOrItLanguage = ["de", "it"].includes(window.settings.language);
    this.$bus.$on("CHANGEVIDEOSPEEDBTN", () => {
      this.isDeOrItLanguage = ["de", "it"].includes(window.settings.language);
    });
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      }
    },
    menuMap() {
      return Object.fromEntries(DRYEYEMENUS.map((v) => [v.key, v]));
    },
    templateMap() {
      return Object.fromEntries(this.detections.templates.map((v) => [v.value, v]));
    },
    currentTemplate() {
      return this.templateMap[this.detections.template];
    },
    currentTemplateItems() {
      return this.currentTemplate.items;
    },
    templateItemsMap() {
      return Object.fromEntries(this.currentTemplateItems.map((v) => [v.key, v]));
    }
  },
  watch: {
    show: {
      handler(val) {
        if (val) {
          this.initSortable();
        } else {
          this.$bus.$emit("update-menu");
        }
      }
    }
  },
  methods: {
    initSortable() {
      this.$nextTick(() => {
        this.sortable = new Sortable(this.$refs.list, {
          animation: 150,
          onEnd: (e) => {
            let oldEl = this.currentTemplateItems.splice(e.oldIndex, 1)[0];
            this.currentTemplateItems.splice(e.newIndex, 0, oldEl);
            this.save();
          }
        });
      });
    },
    addTemplate() {
      this.curTemplate = {
        label: "",
        items: Object.entries(Object.assign({}, this.origin)).map(([key, show]) => ({
          key,
          show
        }))
      };
      this.showTitleDialog = true;
    },
    handleClick() {
      this.$bus.$emit(
        EVENTS.spreadKeyBoard,
        this.curTemplate.label,
        (value) => (this.curTemplate.label = value)
      );
    },
    editTemplate(row) {
      this.curTemplate = row;
      this.showTitleDialog = true;
    },
    getDefaultTemplate() {
      return {
        label: "",
        items: Object.entries(Object.assign({}, this.origin)).map(([key, show]) => ({
          key,
          show
        }))
      };
    },
    saveOrUpdateTemplate() {
      if (!this.curTemplate.label) {
        this.message(this.$t("langcfg.txtInputTemplateTitle"), "error", 1500);
      } else {
        if (!this.curTemplate.value) {
          let value = uuid();
          this.detections.templates.push({ ...this.curTemplate, value });
          this.detections.template = value;
        }
        this.showTitleDialog = false;
        this.save();
      }
    },
    deleteTemplate(index) {
      return this.$confirm(
        this.$t("langcfg.txtDeleteTemplatePrompt"),
        this.$t("langcfg.txtPrompt"),
        {
          confirmButtonText: this.$t("langcfg.txtOK"),
          cancelButtonText: this.$t("langcfg.txtCancel"),
          type: "warning"
        }
      ).then(() => {
        this.detections.templates.splice(index, 1);
        this.detections.template = this.detections.templates[index - 1].value;
        this.save();
      });
    },
    save() {
      saveDelectSettings(window.detectSettings);
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-tree {
  background: transparent;
  .el-tree-node {
    &:hover > .el-tree-node__content,
    &:focus > .el-tree-node__content {
      background: red;
    }

    .el-tree-node__label {
      font-size: 25px;
    }

    .el-tree-node__content {
      height: 50px;
    }

    .el-checkbox__inner {
      width: 25px;
      height: 25px;
      &::after {
        width: 8px;
        height: 14px;
        left: 7px;
      }
    }
  }
}

.el-button {
  background: transparent;
  border: 1px solid gray;
  height: 40px;
  min-width: 100px;
  font-size: 20px;
  padding: 5px;
}

/deep/ .el-input {
  .el-input__inner {
    font-size: 30px;
  }
}

/deep/ .detect-list {
  display: flex;
  flex-direction: column;
  font-size: 20px;

  .el-checkbox {
    display: flex;
    align-items: center;
    .el-checkbox__label {
      font-size: 25px;
    }

    .el-checkbox__inner {
      width: 25px;
      height: 25px;
      &::after {
        width: 8px;
        height: 14px;
        left: 7px;
      }
    }
  }

  > *:not(:first-child) {
    margin-top: 20px;
    display: flex;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/DelectSettings.vue